import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown, ChevronUp, MessageCircle } from 'lucide-react';
import { faqs } from '../../data/mock';

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-start">
          
          {/* ================= LEFT CONTENT ================= */}
          <div className="lg:sticky lg:top-32 self-start">
            <span className="inline-block px-4 py-2 rounded-full bg-gradient-to-r from-[#B8336A]/10 to-[#2D6A6A]/10 text-sm font-medium text-[#B8336A] mb-4">
              Frequently Asked Questions
            </span>

            <h2 className="text-2xl md:text-4xl font-bold text-gray-900 mb-4 leading-snug">
              Find Quick Answers to the Most Asked
              <span className="bg-gradient-to-r from-[#B8336A] to-[#2D6A6A] bg-clip-text text-transparent">
                {" "}Questions
              </span>
            </h2>

            <p className="text-gray-600 text-base md:text-lg mb-6 md:mb-8">
              Can't find what you're looking for? Feel free to reach out to our team for personalized assistance.
            </p>

            <Link
              to="/contact"
              className="inline-flex items-center gap-2 px-6 md:px-8 py-3 md:py-4 bg-gradient-to-r from-[#B8336A] to-[#2D6A6A] text-white rounded-full font-semibold hover:shadow-lg hover:shadow-[#B8336A]/30 transition-all duration-300 hover:-translate-y-1"
            >
              <MessageCircle size={18} />
              Contact Us Now
            </Link>

            {/* IMAGE (ONLY DESKTOP) */}
            <div className="mt-10 hidden lg:block">
              <img
                src="https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=400"
                alt="Support team"
                className="rounded-2xl shadow-lg"
              />
            </div>
          </div>

          {/* ================= FAQ ACCORDION ================= */}
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className={`rounded-2xl border transition-all duration-300 ${
                  openIndex === index
                    ? 'border-[#B8336A]/30 bg-gradient-to-r from-[#B8336A]/5 to-[#2D6A6A]/5 shadow-lg'
                    : 'border-gray-200 bg-white hover:border-gray-300'
                }`}
              >
                {/* QUESTION */}
                <button
                  onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                  className="w-full flex items-center justify-between p-4 md:p-6 text-left"
                >
                  <span
                    className={`font-semibold pr-4 text-sm md:text-base ${
                      openIndex === index
                        ? 'text-[#B8336A]'
                        : 'text-gray-900'
                    }`}
                  >
                    {faq.question}
                  </span>

                  <div
                    className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 transition-colors ${
                      openIndex === index
                        ? 'bg-gradient-to-r from-[#B8336A] to-[#2D6A6A] text-white'
                        : 'bg-gray-100 text-gray-600'
                    }`}
                  >
                    {openIndex === index ? (
                      <ChevronUp size={18} />
                    ) : (
                      <ChevronDown size={18} />
                    )}
                  </div>
                </button>

                {/* ANSWER */}
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    openIndex === index ? 'max-h-screen' : 'max-h-0'
                  }`}
                >
                  <div className="px-4 md:px-6 pb-4 md:pb-6">
                    <p className="text-gray-600 leading-relaxed text-sm md:text-base">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
};

export default FAQSection;